module.exports = __webpack_public_path__ + "static/DHCM1-503cf35b9a3c989a4e1c1583cdc59660.png";